export default "__VITE_ASSET__CeXd3sDM__"